import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ConsentementComponent} from "./consentement/consentement.component";
import {ErrorComponent} from "./error/error.component";
import {CompleteComponent} from "./complete/complete.component";

const routes: Routes = [
  { path: 'complete', component: CompleteComponent },
  { path: 'consentement', component: ConsentementComponent },
  { path: 'error', component: ErrorComponent },
  { path: '**', redirectTo: 'error' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
